export const MAX_WIDTH = 400;
export const MAX_HEIGHT = 400;
